
import init from './init'
import config from './config'
import util from './util'
function DIDA(){
  this.isApp = util.appInfo.inApplication;
  if (this.isApp) {
    this.webview = new init();
    this.appVersion = util.appInfo.version;
  }
}
DIDA.prototype.invoke = function (actionName, data, callback){
  // 返回promise
    if(!this.appVersion || !this.isApp)  console.log('非app环境')
    let version = config.callHandler[actionName] || config.registerHandler[actionName]
    // 判断actionName是否有效
    if(!util.isString(actionName) || !version ) console.log(actionName + '方法不存在！')
    // 判断版本号
    if(util.compareVersion(this.appVersion, version) === -1) console.log(actionName + '方法在' + version + '以后才提供')
    // 参数处理
    let dataList = data
    let fn = util.isFunction(callback) ? callback : ()=>{}
    if(util.isFunction(data)){
      fn = data;
      dataList = {}
    }
    let category = config.callHandler[actionName] ? 'callHandler' : 'registerHandler';
    this.webview[category](actionName, dataList, fn);
}
const dida = new DIDA();
export default {
  invoke: function(...args) {
    return dida.invoke(...args)
  }
}